import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initAll } from 'govuk-frontend';
import App from './App';
import { initialiseTheme } from './lib/theme';
import { initialiseDisplayScale } from './lib/displayScale';





















// Genuine GOV.UK Frontend, configured through its supported Sass API without
// protected government identity assets, followed by the app-owned casework layer.
import './sousa-murray-govuk.scss';
import './sousa-murray-casework.css';

initialiseTheme();
initialiseDisplayScale();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// Initialise any GOV.UK components rendered by the CRM. Components continue
// to work as plain HTML if JavaScript is unavailable.
queueMicrotask(() => initAll());
